export default (function(context,factory){
    return factory();
})(window,function(){

    var kj_model = {};

    var sessionStorage = window.sessionStorage;

    //本地会话数据获取
	kj_model.sessionGet = function(key){
		return sessionStorage&&sessionStorage.getItem(key);
	}

    kj_model.sessionSet = function(key,value){
        sessionStorage&&sessionStorage.setItem(key,value);
    }

	//本地会话数据删除
	kj_model.sessionDel = function(key){
		sessionStorage&&sessionStorage.removeItem(key);
	}

	//清除 所有本地会话数据
	kj_model.sessionClear = function(){
		sessionStorage && sessionStorage.clear();
	}


    return kj_model;

});


// WEBPACK FOOTER //
// ./src/js/storage.js